<template>
  <v-dialog
    v-model="dialog"
    max-width="350"
  >
    <v-card>
      <v-card-title class="headline">
        Registration Information
      </v-card-title>
      <v-card-text>
        <p>To create a mi-SOS account, you need to provide your Email, and password</p>
        <p>Each account can have one or more profiles assigned to it, and you can create a profile as you create an account by clicking the "Create profile" check box</p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false" outlined>Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RegistrationInfo",
  data: () => ({
    dialog: false,
  }),
  methods: {
    openDialog() {
      this.dialog = true;
    },
  }
}
</script>

<style>

</style>